import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import TinyColor from 'tinycolor2';

type ProgressButtonProps = {
  secondsLeft: number;
  totalSeconds: number;
  onClose: () => void;
  buttonText?: string;
  timerText?: string;
};

export const ProgressButton: React.FC<ProgressButtonProps> = ({
  secondsLeft,
  totalSeconds,
  onClose,
  buttonText = 'Close',
  timerText = 'This window will automatically close in {seconds} seconds...',
}) => (
  <>
    <ButtonContainer totalSeconds={totalSeconds} onClick={onClose}>
      <ButtonText>{buttonText}</ButtonText>
    </ButtonContainer>
    {timerText && timerText.length > 0 && <TimerText>{timerText.replace('{seconds}', String(secondsLeft))}</TimerText>}
  </>
);

const progressAnimation = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;

const ButtonContainer = styled.button<{ totalSeconds: number }>`
  ${({ theme: { customized }, totalSeconds }) => css`
    position: relative;
    width: 100%;
    min-height: 64px;
    border: none;
    border-radius: ${customized?.radius?.buttons ?? '24px'};
    background: ${TinyColor.mix(customized.colors.buttonsLinks, '#fff', 10).toString()};
    color: white;
    font-weight: 600;
    font-size: 20px;
    cursor: pointer;
    overflow: hidden;
    padding: 0;
    margin-bottom: 8px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${TinyColor.mix(customized.colors.buttonsLinks, '#000', 10).toString()};
      transform-origin: left;
      animation: ${progressAnimation} ${totalSeconds}s linear forwards;
      z-index: 0;
    }
  `}
`;

const ButtonText = styled.span`
  ${({ theme: { customized } }) => css`
    text-align: center;
    width: 100%;
    position: relative;
    z-index: 1;
    text-transform: ${customized?.textTransforms?.buttons ?? 'uppercase'};
    font: ${customized?.fonts?.primary ?? 'inherit'};
  `}
`;

const TimerText = styled.div`
  font-size: 14px;
  color: ${({ theme: { colors } }) => colors.grey[40]};
  position: relative;
  z-index: 1;
`;
